common.View.create('canvas.blocks.custom.headerImage.Block', {

    onDOMLoad() {

    },

});
